import React, { useState } from 'react';
import './Faq.scss';
import AddIcon from '../../assets/AddIcon.png';
import MinusIcon from '../../assets/MinusIcon.png';

const faqData = [
  {
    question: 'How secure is my file when I use Mypdf.club?',
    answer:
      'Mypdf.club prioritizes the security of your files. We implement robust AES (Advanced Encryption Standard) for file encryption and RSA (Rivest–Shamir–Adleman) for securely transmitting encryption keys. These methods ensure that your files are protected during upload, processing, and storage. We also have strict access controls in place to prevent unauthorized access and maintain your data confidentiality. To journey through our encryption approach in detail, visit our blog.',
  },
  {
    question: 'Can I share encrypted PDFs through WhatsApp or Gmail?',
    answer:
      'Yes, you can share encrypted PDFs through platforms like WhatsApp or Gmail. However, the recipient will need the correct password or decryption key to access the content of the encrypted PDF file.',
  },
  {
    question: 'What file types can I convert to and from PDF?',
    answer:
      'Mypdf.club supports a wide range of file types for conversion to PDF, including DOC, DOCX, PPT, PPTX, JPG, PNG, and more. Similarly, you can often convert PDFs back to these formats, depending on the complexity of the original PDF.',
  },
  {
    question: 'Do I need to install any software to use the tools?',
    answer:
      'No, you do not need to install any software to use the tools on Mypdf.club. Our platform is entirely app-based, meaning you can access all functionalities directly through your our app on any device.',
  },
  {
    question: 'Can I edit text or add images to an existing PDF?',
    answer:
      'Yes, Mypdf.club offers tools to edit existing PDFs. You can typically add or modify text, insert images, annotate, highlight, and perform other editing tasks directly within our online interface.',
  },
];

export default function Faq() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAccordion = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className='faq-container'>
      <div className="section-header">
        <h2>FAQ Section</h2>
        <p>Find Quick Answers to Common Questions About Mypdf.club</p>
      </div>
      <div className='faq-contents'>
        {faqData.map((item, index) => (
          <div className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`} key={index}>
            <div className="question-container" onClick={() => toggleAccordion(index)}>
              <h3>{item.question}</h3>
              <span className="icon">
                {expandedIndex === index ? (
                  <img src={MinusIcon} alt="Minus Icon" />
                ) : (
                  <img src={AddIcon} alt="Add Icon" />
                )}
              </span>
            </div>
            {expandedIndex === index && (
              <div className="answer">
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}